import React from "react";

function GoToSpace() {

    return (

        <div>
            <embed
            src="https://www.virgingalactic.com/visit-the-international-space-station/"
            width={843}
            height={474}
            />
        </div>  

    )

}

export default GoToSpace 